<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-text-field
      v-model="form.name"
      :rules="[validationRules.required]"
      label="Name"
      prepend-icon="fa-user"
    />
    <v-text-field
      v-model="form.number"
      :rules="[validationRules.required]"
      label="Number"
      prepend-icon="fa-hashtag"
    />
  </v-form>
</template>

<script>
export default {
  data () {
    return {
      valid: false,
      form: {
        name: null,
        number: null
      }
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('update', val)
      },
      deep: true
    },
    valid: {
      handler (val) {
        this.$emit('validate', val)
      },
      deep: true
    }
  }
}
</script>
